import { CustomerOrder } from "src/interfaces/order.interface";

/** Matches ActiveOrdersTable / Pay disable rules: external channel orders skip in-house capture. */
export function isChannelCustomerOrder(order: CustomerOrder): boolean {
  return Boolean(order.channelCorrelationId ?? order.channelOrderNumber);
}
